export default __webpack_public_path__ + "static/media/ASSETS-05.ff73bb2e.png";